import { globalStore, settingsStore } from '@gto/gw-store'
import $scriptjs from 'scriptjs'

function checkInitialized() {
  if (!window.fcWidget || !window.fcWidget.isInitialized()) {
    console.warn('CHAT NOT INITIALIZED!!!')
    return false
  }
  return true
}

function chatBubbleVisible() {
  const bubble = document.getElementById('fc_frame')
  return bubble && bubble.classList.contains('fc-bubble_visible')
}
function showChatBubble() {
  if (!checkInitialized()) return
  const bubble = document.getElementById('fc_frame')
  if (bubble) {
    if (!bubble.classList.contains('fc-bubble_visible')) {
      bubble.classList.add('fc-bubble_visible')
    }
  }
}
function hideFreshChatBubble() {
  if (!checkInitialized()) return
  const bubble = document.getElementById('fc_frame')
  if (bubble) {
    bubble.classList.remove('fc-bubble_visible')
  }
}

function openChat() {
  if (!checkInitialized()) return
  showChatBubble()
  setTimeout(() => {
    window.fcWidget.show()
    window.fcWidget.open()
    globalStore.getState().setFreshChatMessages(0)
  }, 200)
}

function appendCloseBtn() {
  if (!checkInitialized()) return

  const bubble = document.getElementById('fc_frame')
  if (bubble) {
    const btnClose = document.createElement('button')
    btnClose.classList.add('fc-bubble_close')
    btnClose.classList.add('gw_btn')
    btnClose.innerHTML = '✖'
    btnClose.onclick = hideFreshChatBubble
    bubble.appendChild(btnClose)
  }
}

// works together with freshChat.scss
// admin -- https://gtowizard-org.myfreshworks.com/
// docs -- https://developers.freshchat.com/web-sdk/v2/#messenger-api
// live-support-env -- you can chat with yourself here  https://gtowizard-org.myfreshworks.com/crm/messaging/a/859839035991492/inbox/0/0/conversation/916347430197927

function initFreshChat() {
  try {
    window.fcWidgetMessengerConfig = {
      email: settingsStore.getState().settings?.email ?? '',
      config: {
        disablePageTransition: true, // no need to track these events
        // headerProperty: {
        // hideChatButton: true, // is this used then show() does not work ... hence its done via css
        // },
      },
    }
    window.fcSettings = {
      onInit() {
        window.fcWidget.on('widget:loaded', appendCloseBtn)
        window.fcWidget.on('unreadCount:notify', function (data) {
          if (chatBubbleVisible()) return
          globalStore.getState().setFreshChatMessages(data.count)
        })
      },
    }
    $scriptjs('https://eu.fw-cdn.com/12749715/741254.js', () => {
      console.log('FreshChat loaded')
    })
  } catch (err) {
    console.error('FreshChat init error', err)
  }
}

export {
  initFreshChat, //
  openChat,
  hideFreshChatBubble,
}
